import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Button } from "primereact/button";
import clotalogo from "../src/images/clotalogo.png";
import "./Header.css"; // Import CSS file
import { FaBars } from "react-icons/fa";

const Header = () => {
  const [menuVisible, setMenuVisible] = useState(false);

  const navItems = [
    { label: "Home", url: "/" },
    { label: "About Site", url: "/about" },
    { label: "Contact Us", url: "/contact" },
  ];

  const handleScrollTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <header className="header">
      <div className="header-container">
        <Link to="/" className="logo-link"
        onClick={() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }}
        >
          <img src={clotalogo} alt="clotaLogo" className="logo-image" />
          <span className="logo-text-header">Database Version</span>
        </Link>

        <nav className="nav-desktop">
          {navItems.map((item) => (
            <NavLink
              key={item.label}
              to={item.url}
              onClick={handleScrollTop}
              className={({ isActive }) =>
                isActive ? "nav-link active" : "nav-link"
              }>
              {item.label}
            </NavLink>
          ))}
        </nav>

        {/* <Button
          icon="pi pi-bars"
          className="menu-button"
          onClick={() => setMenuVisible((prev) => !prev)}
          aria-label="Toggle menu"
        /> */}
              <Button
          className="menu-button"
          onClick={() => setMenuVisible((prev) => !prev)}
          aria-label="Toggle menu"
          icon={<FaBars />}   // yaha react icon lagaya
        />
      </div>

      {menuVisible && (
        <nav className="nav-mobile">
          {navItems.map((item) => (
            <NavLink
              key={item.label}
              to={item.url}
              className="nav-link-mobile"
              onClick={() => setMenuVisible(false)}>
              {item.label}
            </NavLink>
          ))}
        </nav>
      )}
    </header>
  );
};

export default Header;
